import React from 'react';
import { Sankey } from '@ant-design/plots';
import _ from "lodash";


const colors = [
    '#EB4E00',
    '#3A9250',
    '#2A7DD9',
    '#4B20AC',
    '#B2211A',

    // '#edc949',
    // '#af7aa1',
    // '#ff9da7',
    // '#9c755f',
    // '#bab0ab',

    //
    // '#3A9250',
    // '#2A7DD9',
    // '#4B20AC',
    // '#B2211A',
    //

];

const DemoSankey = (props={}) => {
    const getList=(list=[])=>{
        list.forEach((item={},i)=>{
            item.source = item.sourceName ;
            item.target = item.targetName?item.targetName +" ":"";
            item.num = 40;
        });
        const list2=  _.orderBy(list, ['sourceCode', 'targetCode'], ['asc', 'asc']);
        return list2;
    }
    const data =  getList(props.sankeyList)
    const config = {
        data:data,
        scale: {
            color: {
                range: colors,
            },
        },
        width:500,
        height:475,
        yField: 'num',
        layout: {
            // nodeWidth: 0.05,
            // nodeWidth: 0.05,
            nodeSort: (a, b) => b.sort - a.sort,
            nodePadding: 0.05,
            nodeStrokeWidth: 0,
            // style: {
            //     stroke: 'none', // 或者使用 'stroke: transparent;'
            // },
            // nodeLineWidth: 0,
            // lineStroke:"#fff",// 轴线描边色
            // nodeLineStroke:"#fff",
        },
        linkColorField: (d) => d.source.key,
        style: {
            labelFontSize: 14,
            // labelSpacing: -100,
            linkFillOpacity: 0.1,
            labelFill:"#000",// 000000e3 显示文案色
            // stroke: 'none', // 或者使用 'stroke: transparent;'

            labelFontWeight: 'bold',
            // nodeStrokeWidth: 3,
            // labelStroke:0.5,
            // lineWidth: 0,
            // lineLineWidth: 0,
        },
    };
    return <div style={{maxWidth:"500px",margin:"0 auto"}}>
        <Sankey {...config} />
    </div>;
};

export default DemoSankey;